// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* For all DropDownList Popups. */
.k-list-container .k-popup {
  background-color: #fff;
  border: 1px solid rgba(38, 38, 38, 0.3);
  box-sizing: border-box;
  box-shadow: 0px 2px 10px rgba(38, 38, 38, 0.15);
  border-radius: 8px;
  font-weight: normal;
  font-size: 15px;
  color: #262626;
  overflow: hidden;
}
.k-list-container .k-popup .k-list-scroller {
  max-height: unset !important;
}
.k-list-container .k-popup .k-list-scroller .k-item.k-state-focused {
  box-shadow: none;
}
.k-list-container .k-popup .k-list-scroller .k-item.k-state-selected {
  background: #f8f7f3;
  color: #19419b;
  font-weight: bold;
}
.k-list-container .k-popup .k-list-scroller .k-item:hover {
  background-color: #19419b;
  color: #fff;
}
.k-loading-image.fixed::before,
.k-loading-image.fixed::after {
  position: fixed;
}
`, "",{"version":3,"sources":["webpack://./src/commonComponents/commonComponents.less"],"names":[],"mappings":"AAAA,iCAAiC;AAIjC;EACC,sBAAA;EACA,uCAAA;EACA,sBAAA;EACA,+CAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAFD;AAPA;EAYE,4BAAA;AAFF;AAVA;EAeG,gBAAA;AAFH;AAbA;EAmBG,mBAAA;EACA,cAAA;EACA,iBAAA;AAHH;AAlBA;EAyBG,yBAAA;EACA,WAAA;AAJH;AAUC;;EAEC,eAAA;AARF","sourcesContent":["@import (reference) './constants.less';\n@import (reference) '../appComponents/constants.less';\n\n/* For all DropDownList Popups. */\n.k-list-container .k-popup {\n\tbackground-color: #fff;\n\tborder: @fieldBorder;\n\tbox-sizing: border-box;\n\tbox-shadow: 0px 2px 10px rgba(38, 38, 38, 0.15);\n\tborder-radius: 8px;\n\tfont-weight: normal;\n\tfont-size: 15px;\n\tcolor: @grey26;\n\toverflow: hidden;\n\n\t.k-list-scroller {\n\t\tmax-height: unset !important;\n\n\t\t.k-item.k-state-focused {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t.k-item.k-state-selected {\n\t\t\tbackground: @fieldBackgroundWhite;\n\t\t\tcolor: @brightNavy;\n\t\t\tfont-weight: bold;\n\t\t}\n\n\t\t.k-item:hover {\n\t\t\tbackground-color: @brightNavy;\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n}\n\n.k-loading-image.fixed {\n\t&::before,\n\t&::after {\n\t\tposition: fixed;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
